// import React, { useEffect, useState, useRef } from "react";

// const services = [
//   {
//     id: 1,
//     title: "Improved Customer Support",
//     colorClass: "yellow-service",
//     dotClass: "yellow-dot",
//     color: "#FFC250",
//     content1: "Provide timely and personalized support to customers through WhatsApp.",
//   },
//   {
//     id: 2,
//     title: "Enhanced Customer Experience",
//     colorClass: "red-service",
//     dotClass: "red-dot",
//     color: "#E9536C",
//     content1: "Offer a seamless and convenient way for customers to interact with your business.",
//   },
//   {
//     id: 3,
//     title: "Increased Sales",
//     colorClass: "pink-service",
//     dotClass: "pink-dot",
//     color: "#F4B1B8",
//     content1: "Drive sales and conversions by sending targeted promotional messages and offers.",

//   },
//   {
//     id: 4,
//     title: "Better Customer Insights",
//     colorClass: "blue-service",
//     dotClass: "blue-dot",
//     color: "#1EACC0",
//     content1: "Gather valuable customer feedback and insights through WhatsApp conversations.",
//   },
// ];
// const WhatsappBenifits = () => {
//   const [activeIndex, setActiveIndex] = useState(0);
//   const sectionRefs = useRef([]);

//   useEffect(() => {
//     const options = {
//       root: null,
//       rootMargin: "0px 0px -60% 0px", // triggers earlier when top is at 40% of viewport
//       threshold: 0.1,
//     };

//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           const index = Number(entry.target.getAttribute("data-index"));
//           setActiveIndex(index);
//         }
//       });
//     }, options);

//     sectionRefs.current.forEach((ref) => {
//       if (ref) observer.observe(ref);
//     });

//     return () => {
//       sectionRefs.current.forEach((ref) => {
//         if (ref) observer.unobserve(ref);
//       });
//     };
//   }, []);

//   return (
//     <div>
//       <div className="container">
//         <div className="benefitsfont">benefits</div>
//         <div className="benefithead">Business Benefits</div>
//         <div className="d-lg-block d-md-block d-none">
//           <div className="row">
//             {/* Left Side: Sticky Titles */}
//             <div className="col-lg-6 col-md-6">
//               <ul className="list-unstyled sticky-top" style={{ top: "100px" }}>
//                 {services.map((service, index) => {
//                   const isActive = index === activeIndex;
//                   return (
//                     <li
//                       key={service.id}
//                       className={`service-item ${index === activeIndex ? "active" : ""
//                         }`}
//                     >
//                       <div className="d-flex-service-card mb-3">
//                         <div className="border-dot">
//                           <div className={service.dotClass}></div>
//                         </div>
//                         <div
                          
//                         >
//                           <h4
//                             className={`service-heading fs-2 mb-0 `}
//                             style={{
//                               color: isActive ? `${service.color}` : "",
//                             }}
//                             dangerouslySetInnerHTML={{ __html: service.title }}
//                           ></h4>
//                         </div>
//                       </div>
//                     </li>
//                   );
//                 })}
//               </ul>
//             </div>

//             {/* Right Side: Scrollable Sections */}
//             <div className="col-lg-6 col-md-6">
//               {services.map((service, index) => (
//                 <div
//                   key={service.id}
//                   ref={(el) => (sectionRefs.current[index] = el)}
//                   data-index={index}
//                   className="mb-5"
//                   style={{ minHeight: "70vh", paddingTop: "2rem" }}
//                 >
//                   <ul className="list-unstyled">
//                     <li>
//                       <p className="fs-5">{service.content1}</p>
//                     </li>
//                   </ul>

//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//         <div className=" d-lg-none d-md-none d-block">
//           <div className="row ">
//             <div className="col-lg-12">
//               <ul className="list-unstyled">
//                 {services.map((service, index) => {
//                   return (
//                     <li key={index} className={`service-item mb-4 `}>
//                       <div className="d-flex-service-card">
//                         <div className="border-dot">
//                           <div className={service.dotClass}></div>
//                         </div>
//                         <div>
//                           <h4
//                             className={`service-heading fs-2 mb-0 `}
//                             style={{
//                               color: `${service.color}`,
//                             }}
//                             dangerouslySetInnerHTML={{ __html: service.title }}
//                           ></h4>
//                         </div>
//                       </div>
//                       <div className="mb-5">
//                         <ul className="list-unstyled">
//                           <li>
//                             <p className="fs-5">{service.content1}</p>
//                           </li>
//                         </ul>
//                       </div>
//                     </li>
//                   );
//                 })}
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default WhatsappBenifits;
import React from 'react'
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel3";
import benefiticon from "../../assets/images/Benefits icon 1 (1).webp"
const services = [
  {
    id: 1,
    title: "Improved Customer Support",
    points: "Provide timely and personalized support to customers through WhatsApp.",
  },
  {
    id: 2,
    title: "Enhanced Customer Experience",
    points: "Offer a seamless and convenient way for customers to interact with your business.",
  },
  {
    id: 3,
    title: "Increased Sales",
    points: "Drive sales and conversions by sending targeted promotional messages and offers.",

  },
  {
    id: 4,
    title: "Better Customer Insights",
    points: "Gather valuable customer feedback and insights through WhatsApp conversations.",
  },
];
const WhatsappBenifits = () => {
  return (
    <div>
      <div className="benefitsfont">benefits</div>
               <div className="benefithead">Whatsapp Ads</div>
        <div className="mb-5">
                               <div className="container-fluid">
                                 <div className="row">
                                   <div className="col-lg-12">
                                     <div className='benefitwidth'>
                                       <OwlCarousel
                                         className="owl-theme"
                                         loop
                                         autoplay={true}
                                         items="1"
                                         dots={false}
                                         smartSpeed={2000}
                                         nav={true}
                                         navText={[
                                           `<i class="fa fa-chevron-left"></i>`,
                                           `<i class="fa fa-chevron-right"></i>`,
                                         ]}
                                         margin={20}
                                         // center={true}
                                         autoplayTimeout={5000}
                                         responsive={{
                                           360: {
                                             items: "1",
                                           },
                                           414: {
                                             items: "1",
                                           },
                                           670: {
                                             items: "2",
                                           },
                                           992: {
                                             items: "3",
                                           },
                 
                                           1200: {
                                             items: "3",
                                           },
                                         }}
                                       >
                                         {services.map((item, index) => {
                                           return (
                                            <div className="position-circle">
                                              <img  src={benefiticon} className='benefiticon' alt='icon'/>
                                              <div className="border-dot1">
                                            <div className="orange-circle">
                  
                                            </div>
                                            </div>
                                            <div className="carousel-wapp-card">
                                             
            <div>
              <div className="carouselwapp">
            {item.title}
              </div>
              <div className="carousel-para">
            {item.points}
              </div>
            </div>
            
                                            </div>
                                            </div>
                                            
                                           );
                                         })}
                                       </OwlCarousel>
                                     </div>
                                   </div>
                                 </div>
                               </div>
                             </div>
    </div>
  )
}

export default WhatsappBenifits
